<template>
    <div>
      <vs-button
        class="mx-1"
        color="#FA5757"
        type="relief"
        icon="delete"
        size="small"
        :disabled="
          contrato.notaExists == 1 || 
          contrato.id_status == 3 || 
          !$atividades.permissoes.includes(3)"
        @click="modalSyncExcluir = true"
      >
        Excluir Faturamento
      </vs-button>
  
      <vs-popup
        :title="`Excluir Plano de Faturamento do ${contrato.estagio} Nº.${contrato.id}`"
        :active.sync="modalSyncExcluir"
      >
        <div class="w-full vs-con-loading__container" id="popupExcluirPlano">
          <div>
            <vs-row vs-type="flex" vs-align="center">
              <vs-col vs-w="12" vs-type="flex" vs-justify="center" vs-align="center">
                <vs-alert
                  color="danger"
                  title="Atenção"
                  :active="true"
                >
                  Tem certeza que deseja excluir este faturamento? Essa ação não poderá ser desfeita.
                </vs-alert>
              </vs-col>
            </vs-row>
  
            <vs-row class="mt-5" vs-type="flex" vs-align="center">
              <vs-col vs-w="12" vs-type="flex" vs-justify="flex-start" vs-align="center">
                <vs-button
                  class="mx-2 mt-2 excluir"
                  type="danger"
                  icon="delete"
                  size="small"
                  @click="excluirFaturamento"
                  style="font-size: 16px"
                >
                  CONFIRMAR EXCLUSÃO
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-popup>
    </div>
  </template>
  
  <script>
  import components from "@/components/default/exports.js";
  export default {
    props: {
      contrato: {
        required: true,
      },
    },
    data() {
      return {
        modalSyncExcluir: false,
      };
    },
    methods: {
      async excluirFaturamento() {
        await this.$vs.loading({
          container: "#popupExcluirPlano",
          scale: 0.6,
        });
        try {
          // Chamada para excluir o faturamento
          await this.$http.delete(`delete-plano-faturamento/${this.contrato.id}`);
          // Log de exclusão no sistema
          await this.logAssunto();
          this.modalSyncExcluir = false;
          await this.$vs.notify({
            title: "Sucesso",
            text: "Faturamento excluído com sucesso.",
            color: "success",
          });
          // Emitir atualização para o componente pai
          this.$emit("update");
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code === 401) {
            await window.localStorage.clear();
            this.$router.push("/");
          }
        } finally {
          await this.$vs.loading.close("#popupExcluirPlano > .con-vs-loading");
        }
      },
  
      async logAssunto() {
        try {
          await this.$http.post("assuntoCliente", {
            id_assuntos: 16,
            id_cliente: this.contrato.id_cliente,
            id_contrato: this.contrato.id,
            id_estagio: this.contrato.id_estagio,
            status: 3,
            tipo: 6,
            id_colaborador: window.localStorage.getItem("id"),
            obs: `Exclusão do faturamento do contrato N° ${this.contrato.id}`,
          });
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code === 401) {
            await window.localStorage.clear();
            this.$router.push("/");
          }
        }
      },
    },
    components: {
      ...components,
    },
  };
  </script>
  
  <style lang="scss">
  .excluir {
    transition-duration: 50ms;
    background-color: red;
    color: white;
    &:hover {
      transition-duration: 150ms;
      transform: translateY(-3px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
      background-color: darkred;
      color: white;
      cursor: pointer;
    }
  }
  </style>
  